require([
    'jquery',
    'lib/jquery.dataTables'
], function ($) {

    var pageLength = 250;
    var i18n;

    var isBackoffice = $('html.backoffice').length;

    if (companyInfo.lang == 'nl') {
        i18n = {
            decimal: ',',
            thousands: '.',
            search: 'Snelfilter',
            zeroRecords: 'Geen overeenkomende resultaten gevonden',
            columns: 'Kolommen',
            paginate: {
                first: '<i class="ico ico-caret-left"></i><i class="ico ico-caret-left"></i>Eerste',
                previous: '<i class="ico ico-caret-left"></i>Vorige',
                next: 'Volgende<i class="ico ico-end ico-caret-right"></i>',
                last: 'Laatste<i class="ico ico-end ico-caret-right"></i><i class="ico ico-end ico-caret-right"></i>'
            }
        };
    }  else if (companyInfo.lang == 'de') {
        i18n = {
            decimal: ',',
            thousands: '.',
            search: 'Quick filter',
            zeroRecords: 'No matching records found',
            columns: 'Columns',
            paginate: {
                first: '<i class="ico ico-caret-left"></i><i class="ico ico-caret-left"></i>Erste',
                previous: '<i class="ico ico-caret-left"></i>Vorherige',
                next: 'Nächste<i class="ico ico-end ico-caret-right"></i>',
                last: 'Letzte<i class="ico ico-end ico-caret-right"></i><i class="ico ico-end ico-caret-right"></i>'
            }
        };
    }else {
        i18n = {
            decimal: '.',
            thousands: ',',
            search: 'Quick filter',
            zeroRecords: 'No matching records found',
            columns: 'Columns',
            paginate: {
                first: '<i class="ico ico-caret-left"></i><i class="ico ico-caret-left"></i>First',
                previous: '<i class="ico ico-caret-left"></i>Previous',
                next: 'Next<i class="ico ico-end ico-caret-right"></i>',
                last: 'Last<i class="ico ico-end ico-caret-right"></i><i class="ico ico-end ico-caret-right"></i>'
            }
        };
    }

    $.extend($.fn.dataTableExt.oSort, {
        'date-nl-pre': function (a) {
            if (a === '') {
                return 0;
            } else {
                var parts = a.split('-');
                return (parts[2] + parts[1] + parts[0]) * 1;
            }
        },
        'range-pre': function (a) {
            var s;
            if (a === '' || a === '-' || a === '0' || a === 'Unknown' || a === 'Onbekend') {
                return 0;
            } else if (a === '1') {
                return 1;
            } else {
                var index = a.indexOf(' t/m ');
                if (index !== -1) {
                    s = a.substring(0, index);
                } else {
                    index = a.indexOf('-');
                    if (index !== -1) {
                        s = a.substring(0, index);
                    } else {
                        index = a.indexOf('1.000');
                        if (index !== -1) {
                            return 1000;
                        } else {
                            return 0;
                        }
                    }
                }
            }
            return parseFloat(s);
        },
    });

    $.fn.dataTableExt.aTypes.unshift(function (s) {
        if (s === '' || s === '0' || s === '1' || s === '1.000 and more' || s === '1.000 en meer' || s === 'Onbekend' || s === 'Unknown' || /^\d+-\d+$/.test(s) || /^\d+ t\/m \d+$/.test(s)) {
            return 'range';
        }
        return null;
    });

    $.fn.dataTableExt.aTypes.unshift(function (s) {
        if (s === '' || s.match(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-(19|20|21)\d\d$/)) {
            return 'date-nl';
        }
        return null;
    });

    $.extend(companyInfo.decorators, {

        'table': function (e) {
            var table = $(this);
            var rows = $('tr', this).length;
            var columns = $('th:not([data-no-sort])', this).length;
            var customPageLength = this.getAttribute('page-length');
            if(!customPageLength){
                customPageLength=pageLength;
            }
            else{
                customPageLength=parseInt(customPageLength);
            }

            var dataTable = table.dataTable({
                sort: !this.getAttribute('data-no-sort'),
                aaSorting: [],
                paging: rows > (customPageLength + 1),
                pageLength: customPageLength,
                pagingType: 'full_numbers',
                lengthChange: false,
                info: false,
                dom: isBackoffice ? 'ptp' : 'tp',
                language: i18n,
                fnDrawCallback: function (oSettings) {
                    if (oSettings && oSettings.aLastSort.length > 0) {
                        if ($('.fakerow')[0]) {
                            $(".fakerow").hide();
                        }
                        if ($('.clear-sort-button')[0]) {
                            $(".clear-sort-button").show();
                        }
                    }
                },
                fnSortListener: function () {
                    console.log("click sort");
                },
            });


            var api = dataTable.api();

            var panel = table.closest('.panel');
            var options = panel.find('.options');
            if (!options.length) {
                var heading = panel.find('h2');
                options = $('<span class="options"></span>');
                if (!heading.find('span').length) {
                    heading.wrapInner('<span />');
                }
                heading.append(options);
            }

            if (rows > 51 && !this.getAttribute('data-no-filter')) {
                var prev = '';
                var input = $('<input type="search" />');
                input.bind('keyup search input paste cut click', function () {
                    var val = !this.value ? '' : this.value; // mental IE8 fix :-(
                    if (val != prev) {
                        prev = val;
                        api.search(val).draw();
                    }
                    if ($.trim(val) === '') {
                        this.className = '';
                    } else {
                        this.className = 'has-input';
                    }
                }).bind('keypress', function (e) {
                    if (e.keyCode == 13) {
                        return false;
                    }
                });
                var label = $('<label class="quick-search"><i class="ico ico-search"></i>' + i18n.search + '</label>');
                label.append(input);
                options.append(label);
            }

            if (columns > 4 && rows > 51 && !this.getAttribute('data-no-toggle')) {
                api.table().columns().visible(true);
                var filter = $('<ul class="column-filter" />');
                $('th, td', api.table().header()).each(function (i) {
                    var item = $('<li />');
                    var label = $('<label />');
                    var input = $('<input type="checkbox" checked="checked" />').click(function () {
                        var index = $(this).parent().parent().index();
                        api.table().column(index).visible(this.checked);
                        api.columns.adjust().draw();
                    });
                    label.append(input);
                    label.append(' ' + $(this).text());
                    item.append(label);
                    filter.append(item);
                });
                options.append('<button type="button" data-handler="toggle-filter"><i class="ico ico-columns"></i>' + i18n.columns + '</button>');
                options.append(filter);
            }

        },

        // Truncates text and adds ... to it. Used for sector descriptions on organisation search table
        'subTextShorten': function() {
            // Sector descriptions text truncate
            var subText = $(".subText");
            subText.each(function(index) {
                var val = $(this).text();
                if (val) {
                    var changedText = shorten(val, 120);
                    $(this).text(changedText);
                }

            });

            function shorten(text, maxLength) {
                var ret = text;
                if (ret.length > maxLength) {
                ret = ret.substr(0, maxLength-3) + "...";
            }
                return ret;
            }
        }

    });

    

});

define("components/table", function(){});

